import { render } from "./HowtovoteTrad.vue?vue&type=template&id=0a61bf52&scoped=true"
import script from "./HowtovoteTrad.vue?vue&type=script&lang=js"
export * from "./HowtovoteTrad.vue?vue&type=script&lang=js"

import "./HowtovoteTrad.vue?vue&type=style&index=0&id=0a61bf52&lang=scss&scoped=true"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a61bf52"]])

export default __exports__